export const manualRedirectServiceIds = [102277, 104106];

export enum ESubscriptionsType {
    TRYANDBUYSUBSCRIPTIONS = 348,
    REQUIREDPHONESUBSCRIPTIONS = 368,
}
